import React from "react"
import Img from "gatsby-image"
import Slide from 'react-reveal/Slide'


import AniLink from "gatsby-plugin-transition-link/AniLink"

const CompetenceLink = ({ competence }) => (
  
  <div className="flex-auto mx-2">
    <Slide right cascade>
    <AniLink 
     paintDrip
     top="enter"
     hex="#25233D"
    to={competence.frontmatter.path}
    className="flex relative my-4">
      <div className="object-cover w-full h-64 overflow-hidden lg:max-h-full lg:h-full">
    <Img fluid={competence.frontmatter.imageHome.childImageSharp.fluid}/>
    </div>
      <h2
      className="absolute inset-auto bottom-0 pb-12 pl-4 text-white font-bold text-3xl">{competence.frontmatter.title}</h2>
    </AniLink>
    </Slide>
  </div>
)

export default CompetenceLink